import { render, staticRenderFns } from "./ReadOnlyReception.vue?vue&type=template&id=6d2320c5&"
import script from "./ReadOnlyReception.vue?vue&type=script&lang=js&"
export * from "./ReadOnlyReception.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports